import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#fff";
function MINA({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg data-name="Layer 1" viewBox="0 0 24 24" height={size} width={size} fill={color}><path d="M12 20.5c-.7 0-1.2-.5-1.3-1.1v-1.1c-1.5-.4-2.3-1.4-2.5-3L7 5.9h-.8c-.4 0-.8 0-1.2.2v14.2H2.6V8.8c0-1.6.7-2.7 2-3.1V5c0-.9.5-1.4 1.3-1.4s1.3.5 1.4 1.4v.7c1.5.4 2.3 1.5 2.5 3.3l1.1 9.1c.7.1 1.4.1 2 0L14 9c.2-1.8 1.1-2.9 2.4-3.3V5c.2-.9.7-1.4 1.5-1.4s1.3.6 1.3 1.4v.7c1.3.5 2 1.6 2 3.1v11.5h-2.4V6c-.4-.1-.8-.2-1.2-.2h-.8l-1.2 9.4q-.3 2.4-2.4 3v1.1c-.2.7-.7 1.2-1.4 1.1zm-1-2.1v1c.2.4.5.8 1 .7.4 0 .8-.3.8-.7v-1c-.5.1-1.2.1-1.8 0m8.4 1.4h1.5v-11c0-1.3-.5-2.2-1.5-2.6v13.7zm-16.3 0h1.5V6.1c-1 .4-1.5 1.3-1.5 2.6v11zM7.5 6l1.2 9.2c.2 1.3.8 2.2 1.9 2.6L9.5 8.9c-.2-1.6-.8-2.5-2-2.9m9 0c-1.1.4-1.8 1.3-2 2.9l-1.1 8.9c1.1-.4 1.7-1.2 1.9-2.6zM5.1 5.5c.4 0 .8-.1 1.2-.1H7v-.5c-.2-.7-.5-1-1-1s-.9.4-.9 1zm12.7-.1c.4 0 .8 0 1.2.1v-.6c0-.6-.3-1-.9-1s-.9.3-1 1v.5z"  /></Svg>;
}
MINA.DefaultColor = DefaultColor;
export default MINA;